declare var process: any;

import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerReducer, routerMiddleware, replace } from 'react-router-redux';
import * as Cookies from 'js-cookie';
import * as reducers from './reducers';
import { validateAuth } from './actions/auth';
import { requestAppLoad, receiveAppLoad, closeNavigation } from './actions/app';
import { getVehicleTypes } from './actions/vehicleTypes';
import { getAccessories } from './actions/accessories';
import { getVehicles } from './actions/vehicles';

// Initialise Redux
const history = createBrowserHistory();
const rootReducer = combineReducers({
  ...reducers,
  router: routerReducer,
});

// Apply middleware
const enhancer = compose(
  applyMiddleware(thunkMiddleware, routerMiddleware(history)),
);

// Create redux store
const store = createStore(rootReducer, {}, enhancer);

// Close navigation on route change
history.listen(() => {
  const state: any = store.getState();
  if (state.app.isNavigationOpen) {
    store.dispatch(closeNavigation());
  }
  window.scrollTo(0, 0);
});

(async () => {
  // Trigger the app loading state
  store.dispatch(requestAppLoad());

  // Attempt to authenticate user based on cookie
  const localData = Cookies.getJSON(process.env.APP_COOKIE);
  if (localData) {
    await store.dispatch(validateAuth());
    store.dispatch(replace(window.location.pathname));
  }

  // Load core resources
  await Promise.all([
    store.dispatch(getVehicleTypes()),
    store.dispatch(getVehicles()),
    store.dispatch(getAccessories()),
  ]);

  // Finish loading
  store.dispatch(receiveAppLoad());
})();

export { store, history };
